import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getThemeProp } from 'theme';

export const dividerAbsolutePositionStyles = `
  left: 0;
  position: absolute;
  top: 56px;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${getThemeProp('colors.mercuryGrey')};
  margin: unset;
  transform: scaleY(-1);
  width: 100%;
`;

Divider.propTypes = {
  className: PropTypes.string,
};

Divider.defaultProps = {
  className: '',
};

export default Divider;
